import roleApi from '@/api/role'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  errors: [],
  loading: false,
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    roleApi.getAll()
      .then(({ data }) => commit('SET_LIST', data))
  },
  create({ commit }, name) {
    return roleApi.create({ name })
      .then(() => commit('ROLE_CREATED'))
      .catch(error => {
        commit('ROLE_FAILED', error.response.data)
        throw error
      })
  },
  remove({ commit }, id) {
    return roleApi.remove(id)
      .then(() => commit('ROLE_DELETED'))
      .catch(error => {
        commit('ROLE_FAILED', error.response.data)
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, items) {
    state.list = items
    state.loading = false
  },
  ROLE_CREATED() {
    store.dispatch('role/fetchList')
    store.dispatch('message/success', 'Роль создана')
  },
  ROLE_DELETED() {
    store.dispatch('role/fetchList')
    store.dispatch('message/success', 'Роль удалена')
  },

  ROLE_FAILED(state, response) {
    state.errors = response && response.errors ? response.errors : []
    store.dispatch('message/error', (response && response.detail) || 'Не получилось')
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
